<div mat-dialog-title>{{ "users.user.transfer.modal.title" | translate }}</div>
<p></p>
<div mat-dialog-content>
	<div class="flex flex-col gap-y-2">
		<mat-form-field appearance="outline">
			<mat-label>{{ "users.user.transfer.email" | translate }}</mat-label>
			<input
				matInput
				required
				[(ngModel)]="emailAddress" />
			<mat-icon matIconPrefix>email</mat-icon>
		</mat-form-field>
		<app-department-filter
			[placeholder]="'users.user.transfer.department-search' | translate"
			[(departments)]="departments"
			[limitedTo]="userService.getDepartmentsIdAdmin()"></app-department-filter>
	</div>
</div>
<div
	mat-dialog-actions
	[align]="'end'">
	<button
		mat-button
		mat-dialog-close>
		{{ "core.cancel" | translate }}
	</button>
	<mat-spinner
		*ngIf="isLoading"
		diameter="40"
		color="primary"></mat-spinner>
	<button
		mat-raised-button
		color="primary"
		[disabled]="!isEnabled()"
		*ngIf="!isLoading"
		(click)="transfer()">
		{{ "core.transfer" | translate }}
	</button>
</div>
